import { Component, TemplateRef, ViewChild } from '@angular/core';
import { INgSelectTemplate } from '@shared/modules/form-components/select/classes/INgSelectTemplate';

@Component({
  selector: 'app-document-position-selection-option-template',
  templateUrl: './document-position-selection-option-template.component.html',
  styleUrls: ['./document-position-selection-option-template.component.scss'],
})
export class DocumentPositionSelectionOptionTemplateComponent implements INgSelectTemplate {
  @ViewChild(TemplateRef, { static: true, read: TemplateRef })
  templateRef: TemplateRef<HTMLElement>;
}
